import { v4 as uuidv4 } from "uuid";

function uuid(): string {
	return uuidv4();
}

export const utils = {
	uuid,
};
